<div *ngIf="!shipmentPlans || shipmentPlans.length ==0 && !isAdvanceWalmart">
  <ng-container *ngFor="let sku of skusToAddToShipment">
    <div class="create-plan-preview d-flex" [ngClass]="{'plan_error': sku.hasError }">
      <app-sku-view 
      [sku]="sku.sku"
       [qty]="sku.qty"
       [caseQty]="sku.caseQty"
       [isRemove]="true"
       (removeSkuEvent)="removeItem(sku)" 
       (updateqty)="updateqty()" 
       (updateCaseQty)="updateCaseQty($event)"
       [isCaseQty]="isCaseQty"
      ></app-sku-view>
    </div>
    <div class="error" *ngIf="sku.hasError">{{sku.errorMessage}}</div>
   
  </ng-container>
  </div>
  
  <div class="skulist-result-table" [ngClass]="{'plan-shipment-switch' : isNewView }" *ngIf="shipmentPlans && shipmentPlans.length !==0 ">
    <mat-table class="thin-scrollbars" #table [dataSource]="dataSource"[ngClass]="{'newView': isAnyShipmentCreated,'shipments-created': !isShow}">
  
      <ng-container matColumnDef="checked">
        <mat-header-cell *matHeaderCellDef class="checkbox-cell"> <mat-checkbox class="mat-checkbox-custom" [(ngModel)]="master_checked" (change)="setSelectAll($event)" [disabled]="disableCheckbox"></mat-checkbox> </mat-header-cell>
        <mat-cell *matCellDef="let element" class="mid_grey2 checkbox-cell"> 
          <div class="sku_checkbox"><mat-checkbox [ngClass]="{'disabled':element.checkBoxDisable}"  class="mat-checkbox-custom" (change)="selectSku($event)" [(ngModel)]="element.checked" [disabled]="element.shipmentHeaderId"></mat-checkbox></div>
       </mat-cell>
      </ng-container>
  
      <ng-container matColumnDef="destinationId">
        <mat-header-cell *matHeaderCellDef>WH ID </mat-header-cell>      
        <mat-cell *matCellDef="let element" class="mid_grey2"  (click)="toggleRow(element)" [matTooltip]="element.shipmentId"
        >
       <span class="pe-2"><i [ngClass]="element.expanded ? 'fal fa-angle-down': 'far fa-angle-right'"></i></span>
       <span>{{ !isAdvanceWalmart ? element.destinationId : element.shipToAddress.fcName}}</span>
         </mat-cell>
      </ng-container>
  
      <ng-container matColumnDef="skus">
        <mat-header-cell *matHeaderCellDef> SKUs </mat-header-cell>
        <mat-cell *matCellDef="let element" class="mid_grey2" (click)="toggleRow(element)"> {{ !isAdvanceWalmart ? element.skus?.length : element.shipmentItems?.length}} </mat-cell>
      </ng-container>
      
      <ng-container matColumnDef="qty">
        <mat-header-cell *matHeaderCellDef> Qty </mat-header-cell>
        <mat-cell *matCellDef="let element" class="mid_grey2" (click)="toggleRow(element)"> {{element.qty | number}} </mat-cell>
      </ng-container>
    
      <ng-container matColumnDef="shipTo">
        <mat-header-cell *matHeaderCellDef> State </mat-header-cell>
        <mat-cell *matCellDef="let element" class="mid_grey2" (click)="toggleRow(element)"> {{element.shipTo}}</mat-cell>
      </ng-container>
  
      <ng-container matColumnDef="millage">
        <mat-header-cell *matHeaderCellDef> Distance </mat-header-cell>
        <mat-cell *matCellDef="let element" class="mid_grey2" (click)="toggleRow(element)"> {{element.millage | number: '1.0-0'}}  mi</mat-cell>
      </ng-container>
      <ng-container matColumnDef="fees">
        <mat-header-cell *matHeaderCellDef> Fees </mat-header-cell>
        <mat-cell *matCellDef="let element" class="mid_grey2"> 
          <div *ngIf="isBound">
          <span>${{ element.totalNetTransferCharge | number}} Fee</span>
        </div> </mat-cell>
      </ng-container>
      <!-- <ng-container matColumnDef="shipmentHeaderId">
        <mat-header-cell *matHeaderCellDef>  </mat-header-cell>
        <mat-cell *matCellDef="let element" class="mid_grey2" (click)="toggleRow(element)">
          <div class="shipment_title d-flex ms-auto me-1" *ngIf="element.shipmentHeaderId || isWalmart">
            <span class="shipment_name me-2 shipment_link" [routerLink]="['/shipyard/shipments/detail', element.shipmentHeaderId]">
              {{element.shipmentId}}
            </span>
            <span class="shipment_link"  [routerLink]="['/shipyard/shipments/detail', element.shipmentHeaderId]">
              <i _ngcontent-rll-c231="" class="fal fa-external-link-square-alt"></i>
            </span>
          </div>      
        </mat-cell>
      </ng-container> -->
  
      <ng-container matColumnDef="shipmentId">
        <mat-header-cell *matHeaderCellDef> Shipment Name </mat-header-cell>
        <mat-cell *matCellDef="let element" class="mid_grey2">  
          <input 
          class="form-control form-control-sm data-input" 
          type="text" 
          [(ngModel)]="element.shipmentName" 
          placeholder="(Optional)"
          (keypress)="restrictSpecialChar($event)"
          [readOnly]="element.disableShipmentName"
          required
        />   
         </mat-cell>
    
      </ng-container>
  
      <ng-container matColumnDef="AddAllHere">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element" class="mid_grey2"> 
          <div class="shipment_title d-flex align-items-center ms-auto me-1" *ngIf="element.shipmentHeaderId || isWalmart">
            <span class="shipment_name me-2 shipment_link" [routerLink]="['/shipyard/shipments/detail', element.shipmentHeaderId]">
              {{element.shipmentId}}            
            </span>
            <i class="fal icon text-primary" [ngClass]="{ 'fa-copy': !element?.copied, 'fa-check': element.copied }"
                [cdkCopyToClipboard]="element.shipmentId" (cdkCopyToClipboardCopied)="copy($event,element)">
              </i>
          </div>  
         <div class="add-plan text-end" [matTooltip]="'Try combining all to this FC'" [ngClass]="{'add-shipment' : isNewView}" *ngIf="isShow && !element.planCreated">
          <span class="add-plan-btn primary" [ngClass]="{'disabled':element.disable, 'add-shipment' : isNewView}" (click)="AddAllHere(element)" *ngIf="!element?.loading && !element?.error && !element?.success && !isAddAll && shipmentPlans.length > 1 && userInfo.isShipyard !== 3">
            <img *ngIf="element.loader" src="assets/images/loading.gif" class="loader-img me-1" />Round Up</span> 
        <span class="add-plan-btn primary" [ngClass]="{'disabled':element.loading}" *ngIf="element.loading"><img src="assets/images/loading.gif" class="loader-img me-1" />Adding..</span>
         <span class="add-plan-btn warning" (click)="AddAllHere(element)" *ngIf="element?.error && !element?.loading  && !element?.success"><i class="fal fa-exclamation-triangle me-1"></i>Try Again</span>
         <div class="d-flex align-items-end flex-column mt-1" *ngIf="element?.success">
            <span class="add-plan-btn success"><i class="fas fa-check-circle me-1"></i>All added</span>
            <div class="info">Press create to create shipment</div>
          </div>
         </div>
         </mat-cell>
      </ng-container>
  
      <ng-container matColumnDef="export">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element" class="mid_grey2"> 
          <div class="add-plan text-center">
            <span class="add-plan-btn primary" (click)="exportShipment(element)" matTooltip="Export plan results">
              <svg width="10" height="12" class="mb-1"><use xlink:href="assets/images/sprite-icons.svg#file-arrow-down"></use></svg>
            </span>
          </div>
         </mat-cell>
      </ng-container>
  
      <ng-container matColumnDef="create">
        <mat-header-cell *matHeaderCellDef><div class="add-plan text-end"><span class="add-plan-btn primary" *ngIf="!isAdvanceWalmart" (click)="createAll()">Create All</span></div></mat-header-cell>
        <mat-cell *matCellDef="let element" class="mid_grey2">
         <div class="add-plan text-end">
          <span class="add-plan-btn primary" matTooltip="Create this shipment" (click)="isAdvanceWalmart ? createWalmart(true) : create(element)" [ngClass]="{'disabled' : shipyardService.loadCreateShipment || element.planCreated}">
            <img *ngIf="element.loadCreateButton" src="assets/images/loading.gif" class="loader-img me-1" />Create</span> 
         </div>
         </mat-cell>
      </ng-container>
  
      <ng-container matColumnDef="expandedDetail">
        <mat-cell *matCellDef="let detail" class="skulist-cell sku-detail">
        <ng-container *ngFor="let sku of (!isAdvanceWalmart ? detail.element.skus : detail.element.shipmentItems)">
          <div class="sku-detail-view">
            <app-sku-view [sku]="sku"></app-sku-view>
            <div class="skuqty">
              <span class="label">Qty</span>
              <span class="qty-box">{{sku.qty || sku.Qty}}<p class="qty-box_difference" *ngIf="(sku.qty || sku.Qty) - sku.originalQty">{{(sku.qty || sku.Qty) - sku.originalQty}}</p></span>
            </div>
          </div>
        </ng-container>
        </mat-cell>
      </ng-container>
  
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;  let i = index;"
              matRipple 
              class="element-row"            
              [class.expanded]="row.expanded"
              [class.element-row-border-blue]="row.planCreated"        
              ></mat-row>
      <mat-row *matRowDef="let row; columns: ['expandedDetail']; when: isExpansionDetailRow"
              [@detailExpand]="row.element.expanded ? 'expanded' : 'collapsed'"
              style="overflow: hidden"> 
      </mat-row>
    </mat-table>
  </div>
  
  <div class="add-plan ps-2 mt-2 text-end" *ngIf="isAdvanceWalmart && !isBound">
    <span class="add-plan-btn primary" (click)="createWalmart()">Create</span>
  </div>  
  
  <div class="shipment-plans" *ngIf="shipmentPlans && shipmentPlans.length !==0 && isNewView"> 
    <div class="shipment-plans_notification">
      <p *ngIf="shipyardService.planProcessWithDestination.length || shipyardService.planProcess.length"> Working to match your chosen FC, while exploring other options.
      </p>   
      <p *ngIf="!shipyardService.planProcessWithDestination.length && !shipyardService.planProcess.length && shipmentPlanPreview.length">
        As per amazon policy, all corresponding proposals must be created and used.
      </p> 
    </div>
  
     <ng-container *ngIf="isShowProgress">   
      <div class="position-relative">
        <div class="progress-bar_text" [ngClass]="progressbarValue > 50 ? 'text-white': ''"> {{progressbarValue }}% </div> 
      <mat-progress-bar
        mode="determinate"
        [value]="progressbarValue"
      >
      
      </mat-progress-bar>
      </div>
     </ng-container>
     
   
    <div class="plan-shipment_result-table thin-scrollbars" *ngIf="shipmentPlanPreview.length">
      <div class="plan-shipment_sku-list">
        <div class="plan-shipment_result">
        <app-plan-added [shipmentPlanPreview]="shipmentPlanPreview" [exactMatch]="exactMatch" [onChange]="refresh" [account]="account" [isCaseQty]="isCaseQty" 
         (startProgress)="startProgress()" (resetPlan)="resetLoading()" [userInfo]="userInfo" [searchWarehouseId]="searchWarehouseId" 
         [skusToAddToShipment]="skusToAddToShipment" [selectedAddress]="selectedAddress" [selectedTargetFC]="selectedTargetFC">
        </app-plan-added>
        </div>
      </div>
    </div>
  </div>